import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import { buildURLQueryFromObject } from '../../services/utils';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { getFilterAsMap, ListParams } from '../utils';
import { TeamsFilter, ITeam } from './team';
import { ThunkAPI } from '../rootReducer';

export const fetchTeamsList:AsyncThunk<{ teams: ITeam[] }, ListParams<TeamsFilter>, ThunkAPI> = createAsyncThunk(
  'teams/fetchList',
  (searchParams: ListParams<TeamsFilter>, thunk) => {
    return apiAsyncThunkCreator<{ teams: ITeam[] }, void>({
      endpoint: `teams/${buildURLQueryFromObject(getFilterAsMap<TeamsFilter>(searchParams))}`,
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
